import React from 'react'
import { Grid } from "@mui/material";
import Stack from '@mui/material/Stack';
import CampaignTable from './campaign/CampaignManagement'
import UiInput from '../../_uiMocks/_uiComponents/UiInput';
import { UiButton } from '../../_uiComponents/common/form/UiButton';
import { SearchBarWr } from "../../_uiComponents/common/form/UiInputComponents";
import SearchForm from "./campaign/forms/CampaignManagementFilterForm";
// import UiFileUpload from '../../_uiComponents/common/form/UiFileUpload';
import { UiEditor } from "../../_uiComponents/common/form/UiStyledInputs";
import { UiInputGroupWr } from "../../_uiComponents/common/form/UiInputComponents";

export default function ComponentCatalogue(props) {

    return (
        <>
            <div className='sba-catalog-wr' >
                <Grid container sx={{ p: 5 }}>
                     <Grid item xs="12" lg="12" sx={{ mb: 2 , textAlign:'center'}}>
                        <h1>UI Components</h1>
                    </Grid>
                    <Grid item xs="12" lg="12" sx={{ mb: 2 }}>
                    <a href={"/ui/dashboard"}><h3>Dashboard</h3></a>
                    <a href={"/ui/campaign-management"}><h3>Campagin Management</h3></a>
                    <a href={"ui/manage-data"}><h3>Manage Data</h3></a>
                    </Grid>
                    
                     <Grid item xs="12" lg="4" sx={{ mb: 2 }}>
                        <h3 className='sba-catalog-heading'>Input Components</h3>
                        <UiInput type="text" label="Username" />
                        <UiInput type="password" label="Password" />
                        <UiInput
                                label="Description"
                                placeholder="Max 150 characters"
                                multiline={true}
                                minRows={3}
                                maxRows={5} />
                    </Grid>

                    <Grid item xs="12" lg="12" sx={{ mb: 2 }}>
                        <h3 className='sba-catalog-heading'>WYSIWYG Editor</h3>
                        <UiInputGroupWr title="Setup Features Content">
                            <UiEditor title="description" />
                        
                        </UiInputGroupWr>
                    </Grid>
                    <Grid item xs="12" lg="12" sx={{ mb: 2 }}>
                        <h3 className='sba-catalog-heading'>Buttons</h3>
                        <Stack spacing={2} direction="row" sx={{ width: '100%', pt: 0.6, mb:2 }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Apply" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                    <Grid item xs="12" lg="6" sx={{ mb: 2 }}>
                        <h3 className='sba-catalog-heading'>File Upload Component</h3>
                        {/* <UiFileUpload width="456" height="240" label="Header Image"
                            uploadSize="Min. image size 680px x 125px"/> */}
                    </Grid>
                    <Grid item xs="12" lg="12" sx={{ mb: 2 }}>
                        <h3 className='sba-catalog-heading'>Filter Form</h3>
                        <SearchBarWr>
                            <SearchForm />
                        </SearchBarWr>
                    </Grid>
                    <Grid item xs="12" lg="12" sx={{ mb: 2 }}>
                        <h3 className='sba-catalog-heading'>Data Table</h3>
                        <CampaignTable />
                    </Grid> 

                

                   
                </Grid>
            </div>

        </>
    )
}
